import React from 'react';
import styled, { css } from 'styled-components';
import { media } from 'tsx/theme';

const Div = styled.div`
  background-color: #fff;
  padding: 60px 60px 50px 60px;
  border-radius: 20px;
  position: relative;

  .head {
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
    &:hover {
      transform: scale(1.1);
    }
    transition: transform 0.2s ease-in-out;
  }

  ${media.md(css`
    padding: 40px 30px 20px 30px;
    .head {
      top: 0px;
      right: 0px;
      transform: scale(0.8);
      &:hover {
        transform: scale(0.9);
      }
    }
  `)};
`;

interface SummaryBlockProps {
  title: string;
  onEditClick: () => void;
  children: React.ReactNode;
}

export const SummaryBlock: React.FC<SummaryBlockProps> = ({ title, onEditClick, children }) => {
  return (
    <Div>
      <div className="head" onClick={onEditClick}>
        <svg xmlns="http://www.w3.org/2000/svg" width="61" height="61" viewBox="0 0 61 61" fill="none">
          <g filter="url(#filter0_d_1957_168)">
            <path
              d="M10 14C10 10.134 13.134 7 17 7H44C47.866 7 51 10.134 51 14V41C51 44.866 47.866 48 44 48H17C13.134 48 10 44.866 10 41V14Z"
              fill="white"
            />
          </g>
          <path
            d="M39.4086 20.3118L37.6868 18.59C36.9001 17.8033 35.6202 17.8034 34.8336 18.59L34.1596 19.2639L38.7347 23.839L39.4086 23.1651C40.1971 22.3766 40.1972 21.1003 39.4086 20.3118Z"
            fill="#632573"
          />
          <path
            d="M21.8169 31.981L21.0093 36.342C20.9759 36.5222 21.0334 36.7073 21.163 36.8369C21.2928 36.9667 21.478 37.024 21.658 36.9907L26.0188 36.1831L21.8169 31.981Z"
            fill="#632573"
          />
          <path d="M33.3724 20.0523L22.4173 31.0077L26.9923 35.5828L37.9474 24.6275L33.3724 20.0523Z" fill="#632573" />
          <defs>
            <filter
              id="filter0_d_1957_168"
              x="0"
              y="0"
              width="61"
              height="61"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="5" />
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
              <feBlend mode="multiply" in2="BackgroundImageFix" result="effect1_dropShadow_1957_168" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1957_168" result="shape" />
            </filter>
          </defs>
        </svg>
      </div>
      <h5>{title}</h5>
      <div className="spc30" />
      {children}
    </Div>
  );
};
